/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconDocument = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 20 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        fillRule="evenodd"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M5.5 6.25h9M5.5 10h9M5.5 13.75h9M5.5 17.5h9M17.5 1.5c.828 0 1.5.753 1.5 1.68v17.64c0 .927-.672 1.68-1.5 1.68h-15c-.828 0-1.5-.753-1.5-1.68V3.18c0-.927.672-1.68 1.5-1.68h15z" />
      </g>
    </svg>
  ),
);
